import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay/legacy.js';

import { trackEvent } from 'dibs-tracking';

import { ContemporaryLandingHeaderModule } from '../ContemporaryLandingHeaderModule/ContemporaryLandingHeaderModule.jsx';

const trackClick = splashHeader =>
    trackEvent({
        action: 'featured Promotion #1',
        category: 'contemporary landing page interaction',
        label: `${splashHeader.title} clicked|${splashHeader.cta}`,
    });

const ContemporaryLandingSplashHeaderModuleComponent = ({ contemporaryLandingSplashHeader }) => {
    if (!contemporaryLandingSplashHeader) {
        return null;
    }

    const { cta, imagePath, linkData, subtitle, title } = contemporaryLandingSplashHeader;
    return (
        <ContemporaryLandingHeaderModule
            cta={cta}
            imagePath={imagePath}
            onClick={() => trackClick('splashHeader')}
            subtitle={subtitle}
            title={title}
            linkData={linkData}
        />
    );
};

ContemporaryLandingSplashHeaderModuleComponent.propTypes = {
    contemporaryLandingSplashHeader: PropTypes.object,
};

export const ContemporaryLandingSplashHeaderModule = createFragmentContainer(
    ContemporaryLandingSplashHeaderModuleComponent,
    {
        contemporaryLandingSplashHeader: graphql`
            fragment ContemporaryLandingSplashHeaderModule_contemporaryLandingSplashHeader on ContemporaryLandingSplashHeader {
                ... on ContemporaryLandingSplashHeader {
                    cta
                    imagePath
                    subtitle
                    title
                    linkData {
                        #SeoButton is used in ContemporaryLandingHeaderModule
                        ...SeoButton_linkData
                    }
                }
            }
        `,
    }
);

ContemporaryLandingSplashHeaderModule.propTypes = {
    contemporaryLandingSplashHeader: PropTypes.object,
};
